import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { InstanceparentList } from '../models/instance.model';
import { Projects } from '../models/project.model';
import { ProjectsDetails } from '../models/projectDetails.model';
import { ProjectActivityPackDetails } from '../models/ProjectActivityPackDetails.model';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ParamsApiService } from 'src/app/services/params-api.services';
import { UserUtilityService } from 'src/app/services';

@Injectable({
    providedIn: 'root',
})
export class ProjectmanagerService {
    constructor(
        private ngxUiLoaderService: NgxUiLoaderService,
        private paramsApiService: ParamsApiService,
        private user_utlity: UserUtilityService
    ) {}

    InstanceList: InstanceparentList = new InstanceparentList();
    ProjectList: BehaviorSubject<Projects[]> = new BehaviorSubject<Projects[]>(null);
    ProjectList1: BehaviorSubject<Projects[]> = new BehaviorSubject<Projects[]>(null);
    selectedProject: BehaviorSubject<Projects> = new BehaviorSubject<Projects>(null);
    selectedprojectDetails: BehaviorSubject<ProjectsDetails> = new BehaviorSubject<ProjectsDetails>(null);
    selectedActivitypack: BehaviorSubject<ProjectActivityPackDetails> = new BehaviorSubject<ProjectActivityPackDetails>(null);

    currentProjectTab: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    refreshRecord: BehaviorSubject<ProjectActivityPackDetails> = new BehaviorSubject<ProjectActivityPackDetails>(null);
    isProjectRefresh: Subject<boolean> = new Subject<boolean>();
    isActivityFavChange: EventEmitter<any> = new EventEmitter<string>(null);
    backToProjectPage: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    redirectToProjectBreadCrumb: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    projectsList: Projects[];
    selectedProjectData: Projects;
    selectedWorkpackdata: any;

    isActivityPackSaved: BehaviorSubject<boolean> = new BehaviorSubject<any>(false);

    async getAllProject(): Promise<Projects[]> {
        this.ngxUiLoaderService.start();

        try {
            const data = await this.paramsApiService.getAllProjects().toPromise();

            if (data.success) {
                const favArray = [];
                const unFavArray = [];
                data.response.forEach((x) => {
                    if (x.isFavourite) {
                        favArray.push(x);
                    } else {
                        unFavArray.push(x);
                    }
                });
                const sortedFavArray = this.sortingByname(favArray) ? this.sortingByname(favArray) : [];
                const sortedUnFavArray = this.sortingByname(unFavArray) ? this.sortingByname(unFavArray) : [];

                if (sortedFavArray?.length <= 0) {
                    this.projectsList = [...sortedUnFavArray];
                } else if (sortedUnFavArray.length <= 0) {
                    this.projectsList = [...sortedFavArray];
                } else {
                    this.projectsList = [...sortedFavArray, ...sortedUnFavArray];
                }

                return this.projectsList;
            }

            this.user_utlity.errorModelPopup(data.message);
            return [];
        } finally {
            this.ngxUiLoaderService.stop();
        }
    }

    findKeysWithIsOwnerTrue(data) {
        const result = [];
        const startDate = [];
        const endDate = [];
        const logoImg = [];

        // Iterate through the data array
        for (const section of data) {
            // Check if it's a section and has fields
            if (section.type === 'section' && section.groups) {
                // Iterate through fields to find the one with isowner: true
                for (const group of section.groups) {
                    if (group.type === 'group' && group.fields) {
                        for (const field of group.fields) {
                            if (field.isowner === 'true') {
                                result.push(field.key);
                            } else if (field.datetype == 'startdate') {
                                startDate.push(field.key);
                            } else if (field.datetype == 'enddate') {
                                endDate.push(field.key);
                            } else if (field.imageoption == 'logo') {
                                logoImg.push(field.key);
                            }
                        }
                    }
                }
            } else {
                if (section.type == 'tab' && section.section) {
                    for (const sec of section.section) {
                        if (sec.type == 'section' && sec.group) {
                            for (const group of sec.group) {
                                if (group.type === 'group' && group.fields) {
                                    for (const field of group.fields) {
                                        if (field.isowner === 'true') {
                                            result.push(field.key);
                                        } else if (field.datetype == 'startdate') {
                                            startDate.push(field.key);
                                        } else if (field.datetype == 'enddate') {
                                            endDate.push(field.key);
                                        } else if (field.imageoption == 'logo') {
                                            logoImg.push(field.key);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        return [result, startDate, endDate, logoImg];
    }

    getSelectedCardBody(arg0: string) {
        throw new Error('Method not implemented.');
    }

    findAndReturnValuefromStatistics(data, searcKey) {
        const childCountObject = data.find((item) => item.key === searcKey);
        const childCountValue = childCountObject ? childCountObject.value : null;
        return childCountValue;
    }

    sortingByname(array): Array<any> {
        if (array.length) {
            return (array = array.sort((a, b) => {
                const nameA = a.namePrimary.toLowerCase();
                const nameB = b.namePrimary.toLowerCase();

                if (nameA < nameB) return -1;
                if (nameA > nameB) return 1;
                return 0;
            }));
        }
        return [];
    }
}
